import Add from '@src/v3/assets/svg/add';
import AddSquare from '@src/v3/assets/svg/addSquare';
import FinacialIcon from '@src/v3/assets/svg/financial';
import Doller from '@src/v3/assets/svg/doller';
import ListingDetailWallet from '@src/v3/assets/svg/listingDetailWallet';
import Bar from '@src/v3/assets/svg/bar';
import Share from '@src/v3/assets/svg/share';
import Heart from '@src/v3/assets/svg/heart';
import CircleArrowDown from '@src/v3/assets/svg/circleArrowDown';
import CircleArrowRight from '@src/v3/assets/svg/circleArrowRight';
import Chat from '@src/v3/assets/svg/chat';
import Task from '@src/v3/assets/svg/task';
import Profile from '@src/v3/assets/svg/profile';
import Bell from '@src/v3/assets/svg/bell';
import Varification from '@src/v3/assets/svg/varification';
import ShieldVerification from '@src/v3/assets/svg/shieldVerification';
import DocumentText from '@src/v3/assets/svg/documentText';
import Messages from '@src/v3/assets/svg/messages';
import UserAvatar from '@src/v3/assets/svg/userAvatar';
import LoaderDots from '@src/v3/assets/svg/loaderDots';
import Wallet from '@src/v3/assets/svg/wallet';
import Error from '@src/v3/assets/svg/error';
import CopySuccess from '@src/v3/assets/svg/copySuccess';
import Copy from '@src/v3/assets/svg/copy';
import Location from '@src/v3/assets/svg/location';
import Sms from '@src/v3/assets/svg/sms';
import Call from '@src/v3/assets/svg/call';
import ArrowLeft from '@src/v3/assets/svg/arrowLeft';
import BlueTick from '@src/v3/assets/svg/blueTick';
import EmailSent from '@src/v3/assets/svg/emailSent';
import Facebook from '@src/v3/assets/svg/facebook';
import Instagram from '@src/v3/assets/svg/instagram';
import Tiktok from '@src/v3/assets/svg/tiktok';
import Linkedin from '@src/v3/assets/svg/linkedin';
import Twitter from '@src/v3/assets/svg/twitter';
import Spotify from '@src/v3/assets/svg/spotify';
import LinkExpire from '@src/v3/assets/svg/linkExpire';
import ArrowRight from '@src/v3/assets/svg/arrowRight';
import Cross from '@src/v3/assets/svg/cross';
import TickCircle from '@src/v3/assets/svg/tickCircle';
import SendSqaure from '@src/v3/assets/svg/sendSqaure';
import Refresh from '@src/v3/assets/svg/refresh';
import ArrowDown from '@src/v3/assets/svg/arrowDown';
import SendInvite from '@src/v3/assets/svg/sendInvite';
import CrossIcon from '@src/v3/assets/svg/crossIcon';
import NoResultFound from '@src/v3/assets/svg/noResult';
import HeartNotFill from '@src/v3/assets/svg/heartNotFill';
import HeartFill from '@src/v3/assets/svg/heartFill';
import CreditCheck from '@src/v3/assets/svg/creditCheck';

import Pets from '@src/v3/assets/svg/pets';
import Sidebar from '@src/v3/assets/svg/sidebar';
import HomeKey from '@src/v3/assets/svg/homeKey';
import Ordering from '@src/v3/assets/svg/ordering';
import Settings from '@src/v3/assets/svg/setting';
import ZemeBetaLogo from '@src/v3/assets/svg/zemeBetaLogo';
import Download from '@src/v3/assets/svg/download';
import CheckBullets from '@src/v3/assets/svg/checkBullets';
import CardPos from '@src/v3/assets/svg/cardPos';
import CardTick from '@src/v3/assets/svg/cardTick';
import UserSquare from '@src/v3/assets/svg/userSquare';
import ProfileAdd from '@src/v3/assets/svg/profileAdd';
import GPay from '@src/v3/assets/svg/gpay';
import ApplePay from '@src/v3/assets/svg/applePay';
import Trash from '@src/v3/assets/svg/trash';
import Document from '@src/v3/assets/svg/document';
import CopyTwo from '@src/v3/assets/svg/copyTwo';
import ChatTwo from '@src/v3/assets/svg/chatTwo';
import Info from '@src/v3/assets/svg/info';
import HomeTradeUp from '@src/v3/assets/svg/homeTradeUp';
import TagUser from '@src/v3/assets/svg/tagUser';
import UserTick from '@src/v3/assets/svg/userTick';
import CrossFill from '@src/v3/assets/svg/crossFill';
import TickCircleFill from '@src/v3/assets/svg/tickCircleFill';
import AiMarketing from '@src/v3/assets/svg/aiMarketing';
import SmsNotification from '@src/v3/assets/svg/smsNotification';
import InfoCircle from '@src/v3/assets/svg/infoCircle';
import Notes from '@src/v3/assets/svg/notes';
import Notes2 from '@src/v3/assets/svg/notes2';
import InfoCircleWhite from '@src/v3/assets/svg/infoCircleWhite';
import MultiBuildings from '@src/v3/assets/svg/multiBuildings';
import ExlamationTriangle from '@src/v3/assets/svg/exlamationTriangle';
import Tag from '@src/v3/assets/svg/tag';
import Search from '@src/v3/assets/svg/search';
import Pencil from '@src/v3/assets/svg/pencil';
import Pencil2 from '@src/v3/assets/svg/pencil2';

import PhotoId from '@src/v3/assets/svg/photoId';

import Building from '@src/v3/assets/svg/building';
import PersonalCard from '@src/v3/assets/svg/personalCard';
import SimCard2 from '@src/v3/assets/svg/simCard';
import TaskSquare from '@src/v3/assets/svg/taskSquare';
import Card from '@src/v3/assets/svg/card';
import Computing from '@src/v3/assets/svg/computing';
import Teacher from '@src/v3/assets/svg/teacher';
import Briefcase from '@src/v3/assets/svg/briefcase';
import KeySquare from '@src/v3/assets/svg/keySquare';
import DollarSquare from '@src/v3/assets/svg/dollarSquare';
import Reciept2 from '@src/v3/assets/svg/recieptItem';
import Back from '@src/v3/assets/svg/back';
import Email from '@src/v3/assets/svg/email';
import ZoomIn from '@src/v3/assets/svg/zoomIn';
import ZoomOut from '@src/v3/assets/svg/zoomOut';
import ChevronRight from '@src/v3/assets/svg/chevronRight';
import ChevronLeft from '@src/v3/assets/svg/chevronLeft';
import ChevronDown from '@src/v3/assets/svg/chevronDown';
import Price from '@src/v3/assets/svg/price';
import Room from '@src/v3/assets/svg/room';
import Amenities2 from '@src/v3/assets/svg/amenities2';
import Size from '@src/v3/assets/svg/size';
import Plus from '@src/v3/assets/svg/plus';
import Minus from '@src/v3/assets/svg/minus';
import Map from '@src/v3/assets/svg/map';
import Filter from '@src/v3/assets/svg/filter';
import CallWhite from '@src/v3/assets/svg/callWhite';
import AngleLeft from '@src/v3/assets/svg/angleLeft';
import Google from '@src/v3/assets/google';
import Apple from '@src/v3/assets/svg/apple';
import EmailWhite from '@src/v3/assets/svg/emailWhite';
import Bed from '@src/v3/assets/svg/bed';
import Bath from '@src/v3/assets/svg/bath';
import ArrowVertical from '@src/v3/assets/svg/arrowsVertical';
import Calendar from '@src/v3/assets/svg/calendar';
import Home from '@src/v3/assets/svg/home';
import CopyLink from '@src/v3/assets/svg/copyLink';
import WhatsApp from '@src/v3/assets/svg/whatsApp';
import LogOut from '@src/v3/assets/svg/logOut';
import HomeLocation from '@src/v3/assets/svg/homeLocation';
import UserIcon from '@src/v3/assets/svg/userIcon';
import SettingsIcon from '@src/v3/assets/svg/settings';
import BackArrow from '@src/v3/assets/svg/backArrow';
import TrashIcon from '@src/v3/assets/svg/trashIcon';
import ChevronRightIcon from '@src/v3/assets/svg/chevronRIghtIcon';
import TickIcon from '@src/v3/assets/svg/tickIcon';
import IdentificationBadge from '@src/v3/assets/svg/identificationBadge';
import Receipt from '@src/v3/assets/svg/receipt';
import ShirtFolded from '@src/v3/assets/svg/shirtFolded';
import Tax from '@src/v3/assets/svg/tax';
import HouseLine from '@src/v3/assets/svg/houseLine';
import ReadCv from '@src/v3/assets/svg/readCv';
import Money from '@src/v3/assets/svg/money';
import Identification from '@src/v3/assets/svg/identification';
import UploadFile from '@src/v3/assets/svg/uploadFile';
import Options from '@src/v3/assets/svg/options';
import Users from '@src/v3/assets/svg/users';
import Question from '@src/v3/assets/svg/question';
import InProgress from '@src/v3/assets/svg/inProgress';
import Submitted from '@src/v3/assets/svg/submitted';
import Unavailable from '@src/v3/assets/svg/unavailable';
import MoreHorizontal from '@src/v3/assets/svg/moreHorizontal';
import GreenCheck from '@src/v3/assets/svg/greenCheck';
import PencilOutline from '@src/v3/assets/svg/pencilOutline';
import ShareOutline from '@src/v3/assets/svg/shareOutline';
import Eye from '@src/v3/assets/svg/eye';
import StatsIcon from '@src/v3/assets/svg/statsIcon';
import MessageIcon from '@src/v3/assets/svg/messageIcon';
import CurrencyCircleDollar from '@src/v3/assets/svg/currencyCircleDollar';
import CreditCheckIcon from '@src/v3/assets/svg/creditCheckIcon';
import PawPrint from '@src/v3/assets/svg/pawPrint';
import ListBullets from '@src/v3/assets/svg/listBullets';
import ArrowLineDown from '@src/v3/assets/svg/arrowLineDown';
import WarningCircle from '@src/v3/assets/svg/warningCircle';
import CameraPhoto from '@src/v3/assets/svg/cameraPhoto';
import EditDocument from '@src/v3/assets/svg/editDocument';
import DeleteX from '@src/v3/assets/svg/deleteX';
import UserCircle from '@src/v3/assets/svg/userCircle';
import HourGlass from '@src/v3/assets/svg/hourGlass';
import ChartLineUp from '@src/v3/assets/svg/chartLineUp';
import HandTap from '@src/v3/assets/svg/handTap';
import VerifiedIcon from '@src/v3/assets/svg/verified';
import ChartBarIcon from '@src/v3/assets/svg/chartBar';
import CopyText from '@src/v3/assets/svg/copyText';
import DotsSix from '@src/v3/assets/svg/dotsSix';
import CheckCircle from '@src/v3/assets/svg/checkCircle';
import SealCheck from '@src/v3/assets/svg/sealCheck';
import CloudArrowUp from '@src/v3/assets/svg/cloudArrowUp';
import InformationFill from '@src/assets/svg/informationFill';
import CaretRight from '@src/v3/assets/svg/caretRight';
import EnvelopeSample from '@src/v3/assets/svg/envelopeSample';
import HouseLineIcon from '@src/v3/assets/svg/houseLineIcon';
import PresentationChart from '@src/v3/assets/svg/presentationChart';
import TransactionIcon from '@src/v3/assets/svg/transactionIcon';
import ArrowLineUpRight from '@src/v3/assets/svg/arrowLineUpRight';
import LinkSimple from '@src/v3/assets/svg/linkSimple';
import AiMarketingIcon from '@src/v3/assets/svg/aiMarketingIcon';
import Visa from '@src/v3/assets/svg/visa';
import VisaLogo from '@src/v3/assets/svg/visaLogo';
import LockIcon from '@src/v3/assets/svg/lockIcon';
import CreditCard from '@src/v3/assets/svg/creditCard';
import AddressBook from '@src/v3/assets/svg/addressBook';
import Phone from '@src/v3/assets/svg/phone';
import LinkCopy from '@src/v3/assets/svg/linkCopy';
import Mapping from '@src/v3/assets/svg/mapping';
import Invoice from '@src/v3/assets/svg/invoice';
import Key from '@src/v3/assets/svg/key';
import Article from '@src/v3/assets/svg/article';
import RotateLeft from '@src/v3/assets/svg/rotateLeft';
import Rotate from '@src/v3/assets/svg/rotate';
import NotePencil from '@src/v3/assets/svg/notePencil';
import Camera from '@src/v3/assets/svg/camera';
import CameraIcon from '@src/v3/assets/svg/cameraIcon';
import ErrorCode from '@src/v3/assets/svg/errorCode';
import CalendarIcon from '@src/v3/assets/svg/calendarIcon';
import TrashDelete from '@src/v3/assets/svg/trashDelete';
import SendIcon from '@src/v3/assets/svg/sendIcon';
import WarningIcon from '@src/v3/assets/svg/warningIcon';
import CheckCircleOutline from '@src/v3/assets/svg/checkCircleOutline';
import DownloadArrow from '@src/v3/assets/svg/downloadArrow';
import ChevronLeftThin from '@src/v3/assets/svg/chevronLeftThin';
import UsersThree from '@src/v3/assets/svg/usersThree';
import BankIcon from '@src/v3/assets/svg/bankIcon';
import FileIcon from '@src/v3/assets/svg/fileIcon';
import EyeCross from '@src/v3/assets/svg/eyeCross';
import ShareIcon from '@src/v3/assets/svg/shareIcon';
import CaretDown from '@src/v3/assets/svg/caretDown';

// Icon list
// Note: if someone from dev has added any new icon then please add it here.
const iconList = {
  add: Add,
  addSquare: AddSquare,
  financialIcon: FinacialIcon,
  doller: Doller,
  listingDetailWallet: ListingDetailWallet,
  bar: Bar,
  share: Share,
  heart: Heart,
  circleArrowDown: CircleArrowDown,
  circleArrowRight: CircleArrowRight,
  profile: Profile,
  task: Task,
  bell: Bell,
  varification: Varification,
  shieldVerification: ShieldVerification,
  document: Document,
  documentText: DocumentText,
  messages: Messages,
  userAvatar: UserAvatar,
  lodaerdots: LoaderDots,
  wallet: Wallet,
  error: Error,
  copySuccess: CopySuccess,
  copy: Copy,
  copyLink: CopyLink,
  copyTwo: CopyTwo,
  location: Location,
  call: Call,
  sms: Sms,
  arrowLeft: ArrowLeft,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  chevronDown: ChevronDown,
  blueTick: BlueTick,
  emailSent: EmailSent,
  email: Email,
  facebook: Facebook,
  instagram: Instagram,
  tiktok: Tiktok,
  linkedin: Linkedin,
  twitter: Twitter,
  whatsapp: WhatsApp,
  spotify: Spotify,
  linkExpire: LinkExpire,
  arrowRight: ArrowRight,
  cross: Cross,
  tick: TickIcon,
  tickcircle: TickCircle,
  sendsqaure: SendSqaure,
  refresh: Refresh,
  arrowdown: ArrowDown,
  sendinvite: SendInvite,
  crossicon: CrossIcon,
  noresultfound: NoResultFound,
  heartnotfill: HeartNotFill,
  heartfill: HeartFill,
  creditcheck: CreditCheck,
  pets: Pets,
  sidebar: Sidebar,
  homekey: HomeKey,
  chat: Chat,
  chatTwo: ChatTwo,
  ordering: Ordering,
  settings: Settings,
  zemebetalogo: ZemeBetaLogo,
  download: Download,
  checkbullets: CheckBullets,
  cardPos: CardPos,
  cardtick: CardTick,
  userquare: UserSquare,
  profileAdd: ProfileAdd,
  gpay: GPay,
  applePay: ApplePay,
  trash: Trash,
  pencil: Pencil,
  pencil2: Pencil2,
  info: Info,
  homeTradeUp: HomeTradeUp,
  tagUser: TagUser,
  userTick: UserTick,
  crossFill: CrossFill,
  tickCircleFill: TickCircleFill,
  aiMarketing: AiMarketing,
  smsNotification: SmsNotification,
  infoCircle: InfoCircle,
  notes: Notes,
  notes2: Notes2,
  infoCircleWhite: InfoCircleWhite,
  multiBuildings: MultiBuildings,
  checkCircle: CheckCircle,
  exlamationTriangle: ExlamationTriangle,
  tag: Tag,
  searchIcon: Search,
  credit_check: CreditCheck,
  renter_history: ReadCv,
  photo_id: PhotoId,
  tag_user: Identification,
  kid_and_pet: HouseLine,
  receipt_2: Reciept2,
  people: Money,
  bank: BankIcon,
  money_send: Receipt,
  document_text: Document,
  buildings: Building,
  personalcard: PersonalCard,
  simcard_2: SimCard2,
  task_square: TaskSquare,
  card: Card,
  computing: Computing,
  teacher: Teacher,
  briefcase: Briefcase,
  key_square: KeySquare,
  dollar_square: DollarSquare,
  receipt_item: Article,
  letter: IdentificationBadge,
  back: Back,
  zoomIn: ZoomIn,
  zoomOut: ZoomOut,
  price: Price,
  room: Room,
  amenities2: Amenities2,
  size: Size,
  squareFootage: Size,
  plus: Plus,
  minus: Minus,
  map: Map,
  filter: Filter,
  callWhite: CallWhite,
  angleLeft: AngleLeft,
  google: Google,
  apple: Apple,
  emailWhite: EmailWhite,
  bed: Bed,
  bath: Bath,
  arrowVertical: ArrowVertical,
  calendar: Calendar,
  home: Home,
  logout: LogOut,
  homeLocation: HomeLocation,
  userIcon: UserIcon,
  settingsIcon: SettingsIcon,
  backArrow: BackArrow,
  trashIcon: TrashIcon,
  chevronRightIcon: ChevronRightIcon,
  identificationBadge: IdentificationBadge,
  receipt: Receipt,
  shirtFolded: ShirtFolded,
  tax: Tax,
  houseLine: HouseLine,
  readCv: ReadCv,
  money: Money,
  identification: Identification,
  uploadFile: UploadFile,
  options: Options,
  users: Users,
  question: Question,
  inProgress: InProgress,
  submitted: Submitted,
  unavailable: Unavailable,
  moreHorizontal: MoreHorizontal,
  greenCheck: GreenCheck,
  pencilOutline: PencilOutline,
  shareOutline: ShareOutline,
  eye: Eye,
  statsIcon: StatsIcon,
  messageIcon: MessageIcon,
  currencyCircleDollar: CurrencyCircleDollar,
  creditCheckIcon: CreditCheckIcon,
  pawPrint: PawPrint,
  listBullets: ListBullets,
  arrowLineDown: ArrowLineDown,
  warningCircle: WarningCircle,
  cameraPhoto: CameraPhoto,
  editDocument: EditDocument,
  deleteX: DeleteX,
  userCircle: UserCircle,
  hourGlass: HourGlass,
  chartLineUp: ChartLineUp,
  handTap: HandTap,
  verified: VerifiedIcon,
  chartBar: ChartBarIcon,
  copyText: CopyText,
  dotsSix: DotsSix,
  sealCheck: SealCheck,
  cloudArrowUp: CloudArrowUp,
  informationFill: InformationFill,
  caretRight: CaretRight,
  envelopeSample: EnvelopeSample,
  houseLineIcon: HouseLineIcon,
  presentationChart: PresentationChart,
  transactionIcon: TransactionIcon,
  arrowLineUpRight: ArrowLineUpRight,
  linkSimple: LinkSimple,
  notePencil: NotePencil,
  aiMarketingIcon: AiMarketingIcon,
  visa: Visa,
  visaLogo: VisaLogo,
  lockIcon: LockIcon,
  creditCard: CreditCard,
  addressBook: AddressBook,
  phone: Phone,
  linkCopy: LinkCopy,
  mapping: Mapping,
  key: Key,
  invoice: Invoice,
  article: Article,
  rotate: Rotate,
  rotateLeft: RotateLeft,
  camera: Camera,
  cameraIcon: CameraIcon,
  errorCode: ErrorCode,
  calendarIcon: CalendarIcon,
  trashDelete: TrashDelete,
  sendIcon: SendIcon,
  warningIcon: WarningIcon,
  checkCircleOutline: CheckCircleOutline,
  downloadArrow: DownloadArrow,
  chevronLeftThin: ChevronLeftThin,
  usersThree: UsersThree,
  fileIcon: FileIcon,
  eyeCross: EyeCross,
  shareIcon: ShareIcon,
  caretDown: CaretDown,
};

export { iconList };
